import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/images/newLootkaFont.webp';
import ins from "../assets/icons/logo-instagram.svg";
import wat from "../assets/icons/logo-whatsapp.svg";
import tel from "../assets/icons/telegram-circled.svg";
import phone from "../assets/icons/device-phone.svg"
import loc from "../assets/icons/newLocation.svg";
import email from "../assets/icons/mail-1.svg";
import lnk from "../assets/icons/icons8-linkedin 1.svg"
import { trackEvent } from "../utils/analytics";

const footerSeoLinks = [
  { label: "جاذبه‌های دیدنی گیلان", to: "/places/category/جاذبه%E2%80%8Cهای%20دیدنی" },
  { label: "رستوران‌های گیلان", to: "/places/category/رستوران" },
  { label: "کافه‌های گیلان", to: "/places/category/کافه" },
  { label: "اقامتگاه‌های گیلان", to: "/places/category/اقامتگاه" },
  { label: "شهرهای گیلان", to: "/destinations" },
  { label: "سفر به رشت", to: "/places/city/رشت" },
  { label: "سفر به لاهیجان", to: "/places/city/لاهیجان" },
  { label: "سفر به بندر انزلی", to: "/places/city/بندر%20انزلی" },
  { label: "سفر به رودسر", to: "/places/city/رودسر" },
  { label: "سفر به رامسر", to: "/places/city/رامسر" },
];

const Footer = () => {
  return (
    <footer className="mt-12 border-t border-gray-200 bg-[#FBFBFA]">
      <div className="site-container py-8 tablet:py-10">
        <div className="grid grid-cols-2 gap-8 border-b border-gray-200 pb-8 tablet:grid-cols-[minmax(0,1.35fr)_minmax(0,0.75fr)_minmax(0,1fr)] tablet:gap-10 desktop:gap-16">
          <section className="col-span-2 max-w-md tablet:col-span-1">
            <div className="flex items-center gap-3">
              <Link to="/" aria-label="لوتکا، صفحه اصلی" className="inline-flex shrink-0 rounded-md focus:outline-none focus:ring-2 focus:ring-[#038545] focus:ring-offset-2">
                <img src={logo} alt="لوتکا" className="h-10 w-auto object-contain tablet:h-11" />
              </Link>
              <p className="text-xs leading-6 text-gray-600 font-myYekanFaNumRegular tablet:text-sm tablet:leading-7">
                لوتکا یک بستر جامع برای کشف بهترین مکان‌های گردشگری، اقامتی و رستوران‌ها در شهرهای شمال ایران است.
              </p>
            </div>
            <span className="mt-3 block [&_img]:h-14 [&_img]:w-auto"
              dangerouslySetInnerHTML={{
                __html: "<a referrerpolicy='origin' target='_blank' href='https://trustseal.enamad.ir/?id=7837304&Code=5xkaLDJg7SCBjnSgTevrxNnYune4gk9F'><img referrerpolicy='origin' src='https://trustseal.enamad.ir/logo.aspx?id=7837304&Code=5xkaLDJg7SCBjnSgTevrxNnYune4gk9F' alt='' style='cursor:pointer' code='5xkaLDJg7SCBjnSgTevrxNnYune4gk9F'></a>",
              }}
            />
          </section>

          <nav aria-labelledby="footer-quick-links">
            <h2 id="footer-quick-links" className="mb-4 text-sm text-gray-900 font-myYekanFaNumDemiBold">دسترسی سریع</h2>
            <ul className="space-y-3 text-xs text-gray-600 font-myYekanFaNumRegular tablet:text-sm">
              <li><Link to="/places/category/رستوران" className="transition-colors hover:text-[#038545] focus:outline-none focus:text-[#038545]">رستوران‌ها</Link></li>
              <li><Link to="/places/category/جاذبه%E2%80%8Cهای%20دیدنی" className="transition-colors hover:text-[#038545] focus:outline-none focus:text-[#038545]">جاذبه‌های دیدنی</Link></li>
              <li><Link to="/places/category/اقامتگاه" className="transition-colors hover:text-[#038545] focus:outline-none focus:text-[#038545]">اقامتگاه‌ها</Link></li>
              <li><Link to="/about" className="transition-colors hover:text-[#038545] focus:outline-none focus:text-[#038545]">درباره لوتکا</Link></li>
            </ul>
          </nav>

          <section aria-labelledby="footer-contact">
            <h2 id="footer-contact" className="mb-4 text-sm text-gray-900 font-myYekanFaNumDemiBold">راه‌های ارتباطی</h2>
            <ul className="space-y-3 text-xs text-gray-600 font-myYekanFaNumRegular tablet:text-sm">
              <li className="flex items-center gap-2">
                <img src={email} alt="" className="h-5 w-5 shrink-0" />
                <a href="mailto:lootka.info@gmail.com" className="break-all transition-colors hover:text-[#038545] focus:outline-none focus:text-[#038545]">lootka.info@gmail.com</a>
              </li>
              <li className="flex items-center gap-2">
                <img src={phone} alt="" className="h-5 w-5 shrink-0" />
                <a
                  href="tel:+989115057307"
                  dir="ltr"
                  onClick={() => trackEvent("click_contact_phone", { surface: "footer" })}
                  className="transition-colors hover:text-[#038545] focus:outline-none focus:text-[#038545]"
                >
                  09115057307
                </a>
              </li>
              <li className="flex items-center gap-2">
                <img src={loc} alt="" className="h-5 w-5 shrink-0" />
                <span>ایران، گیلان</span>
              </li>
            </ul>
          </section>

          <nav className="col-span-2 pt-1 tablet:col-span-3" aria-labelledby="footer-travel-links">
            {/* <h2 id="footer-travel-links" className="text-sm text-gray-900 font-myYekanFaNumDemiBold">راهنمای سفر به گیلان</h2> */}
            <ul className="mt-3 flex flex-wrap gap-2" aria-label="لینک‌های سفر و گردشگری گیلان">
              {footerSeoLinks.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="inline-flex rounded-lg border border-gray-200 bg-white px-3 py-1.5 text-[11px] text-gray-600 transition-colors hover:border-[#97d2b5] hover:bg-[#f3fefa] hover:text-[#038545] focus:outline-none focus:ring-2 focus:ring-[#038545] tablet:text-xs"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>
        </div>

        <div className="flex flex-col gap-5 pt-6 tablet:flex-row tablet:items-center tablet:justify-between">
          <p className="text-xs text-gray-500 font-myYekanFaNumRegular">
            © {new Date().getFullYear()} تمامی حقوق محفوظ است.
          </p>
          <ul className="flex items-center gap-2" aria-label="شبکه‌های اجتماعی لوتکا">
            <li><a href="https://t.me/lootkatrip" target="_blank" rel="noopener noreferrer" aria-label="تلگرام لوتکا" className="flex h-9 w-9 items-center justify-center rounded-lg border border-gray-200 bg-white transition-colors hover:border-[#97d2b5] hover:bg-[#f3fefa] focus:outline-none focus:ring-2 focus:ring-[#038545]"><img src={tel} alt="" className="h-5 w-5" /></a></li>
            <li><a href="https://www.instagram.com/lootka.iran/?utm_source=ig_web_button_share_sheet" target="_blank" rel="noopener noreferrer" aria-label="اینستاگرام لوتکا" className="flex h-9 w-9 items-center justify-center rounded-lg border border-gray-200 bg-white transition-colors hover:border-[#97d2b5] hover:bg-[#f3fefa] focus:outline-none focus:ring-2 focus:ring-[#038545]"><img src={ins} alt="" className="h-5 w-5" /></a></li>
            <li><a href="https://wa.me/989019419057" target="_blank" rel="noopener noreferrer" aria-label="واتساپ لوتکا" className="flex h-9 w-9 items-center justify-center rounded-lg border border-gray-200 bg-white transition-colors hover:border-[#97d2b5] hover:bg-[#f3fefa] focus:outline-none focus:ring-2 focus:ring-[#038545]"><img src={wat} alt="" className="h-5 w-5" /></a></li>
            <li><a href="https://www.linkedin.com/company/lootkatrip/" target="_blank" rel="noopener noreferrer" aria-label="لینکدین لوتکا" className="flex h-9 w-9 items-center justify-center rounded-lg border border-gray-200 bg-white transition-colors hover:border-[#97d2b5] hover:bg-[#f3fefa] focus:outline-none focus:ring-2 focus:ring-[#038545]"><img src={lnk} alt="" className="h-5 w-5" /></a></li>
          </ul>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
